import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { DialogAlertComponent } from '../shared/components/dialog-alert/dialog-alert.component';
import { DialogData } from '../shared/model/dialog-data';
import { CartService } from '../shared/services/cart.service';
import { DiscountModalService } from '../shared/services/discount-modal.service';
import { DtmService } from '../services/dtm.service';
import { Dtm } from '../shared/enum/dtm';
import { DtmDataLayer } from '../models/dtm-data-layer';
@Component({
    // tslint:disable-next-line: component-selector
    selector: 'pme-checkout',
    templateUrl: './checkout.component.html',
    standalone: false
})

export class CheckoutComponent implements OnInit {
  canShowModal = false;

  CookieService = {

    setCookie(name, value, days) {
      let expires = '';

      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
      }

      document.cookie = name + '=' + (value || '') + expires + ';';
    },

    getCookie(name) {
      const cookies = document.cookie.split(';');

      for (const cookie of cookies) {
        if (cookie.indexOf(name + '=') > -1) {
          return cookie.split('=')[1];
        }
      }

      return null;
    }
  }
  classificationIdentifier: string;
  exitIntentShownObject = JSON.parse(this.CookieService.getCookie('exitIntentShown')) || {};
  modalAvailableSteps = [];
  daysToDisplayAgain: number;
  businessId: string;
  userId: string;
  validateCookies: boolean;
  discountIdentifierModal: string;
  customMessage: string;
  dtmDataLayer = new DtmDataLayer();

  constructor(private route: ActivatedRoute,
    private sessionStorageService: SessionStorageService,
    private discountModalService: DiscountModalService,
    private cartService: CartService,
    public dialog: MatDialog,
    private router: Router,
    public dtmService: DtmService) {

    const currentStep = JSON.parse(sessionStorage.getItem('currentStep'))
    let currentIndex = null;

    if (currentStep) {
      currentIndex = currentStep.index;
    }

    const checkoutSuccessData = JSON.parse(localStorage.getItem('checkoutSuccessData'));

    // Apaga dados de uma venda previa caso o cliente volte para outra pagina
    // do ecommerce
    if (checkoutSuccessData && currentIndex === 3) {
      localStorage.removeItem('checkoutSuccessData');
    }
    if (!this.sessionStorageService.isReloading() && !this.router.url.includes('/sucesso')) {
      // Usuario acessando pela primeira vez, limpa tudo do sessionStorage
      this.sessionStorageService.resetSessionStorage();
      localStorage.clear();
    }

    this.route.queryParams.subscribe((params) => {
      if (params.userId && params.businessId) {
        this.userId = params.userId;
        this.businessId = params.businessId;
      } else {
        this.userId = this.sessionStorageService.getUserId();
        this.businessId = this.sessionStorageService.getBusinessId();
      }
      if (params.redirectUrl) {
        sessionStorage.setItem('successRedirectUrl', params.redirectUrl);
      }

    });
  }

  ngOnInit(): void {
    const paramMap = this.route.snapshot.paramMap;
    this.classificationIdentifier = paramMap.get('classificationIdentifier');
    if (this.classificationIdentifier) {
      this.sessionStorageService.setClassification(this.classificationIdentifier);

      if (this.userId && this.businessId) {
        this.discountModalService.getDiscountModalConfigAPI(this.classificationIdentifier, this.userId, this.businessId)
          .subscribe((result) => {
            if (result.active && !result.alreadyDisplayed) {
              this.discountModalService.setDiscoutModalConfig(result);
              this.canShowModal = true;
              this.daysToDisplayAgain = result.daysToDisplayAgain;
              this.modalAvailableSteps = result.displayPages;
              this.validateCookies = result.validateCookies;
              this.discountIdentifierModal = result.discountIdentifierModal;
              this.customMessage = result.customMessage;
            }
          }, (err) => {
            //trata erro de API do modal
          });
      }

    }
  }

  doBeforeUnload($event) {
    // console.log('doBeforeUnload');
  }

  onUnload($event): any {
  }

  onMouseOut(e) {

    let exhibitionPage = this.modalAvailableSteps.find(step => this.route.snapshot['_routerState'].url.includes(step));
    const reachedTheTime = this.discountModalService.getReachedTheModalTime();
    let clickCondition = true;

    if (exhibitionPage && exhibitionPage.indexOf("meu") > -1) {
      clickCondition = this.discountModalService.getClickedOnPackages();
    }
    const shouldShowExitIntent =
      (!this.validateCookies || (!this.exitIntentShownObject || !this.exitIntentShownObject[this.classificationIdentifier])) &&
      this.canShowModal &&
      reachedTheTime &&
      exhibitionPage &&
      clickCondition &&
      !e.toElement &&
      !e.relatedTarget &&
      e.clientY < 10;

    if (shouldShowExitIntent) {
    let cart = this.cartService.getCurrentCart();
    if (!cart || !cart.couponIdentifier) {
      this.exitIntentShownObject[this.classificationIdentifier] = true;
      this.CookieService.setCookie("exitIntentShown", JSON.stringify(this.exitIntentShownObject), this.daysToDisplayAgain);
      this.canShowModal = false;
      this.discountModalService.setModalWasDisplayed(this.classificationIdentifier, this.userId, this.businessId, exhibitionPage, this.daysToDisplayAgain)
        .subscribe();
      this.openDiscountDialog();
      }
    }

  }

  /** Abre dialog em caso de erro durante a venda deslogada */
  openDiscountDialog() {
    let data = DialogData.fromPreset("MODAL_DISCOUNT", { customMessage: this.customMessage });

    this.dtmService.customLoaded(["RetentionModalImpression"]);
    const currentProduct = this.cartService.getCurrentCart().product;
    const productWithMerchandising = { ...currentProduct, merchandising: currentProduct };
    this.dtmService.productsLoaded([productWithMerchandising]);
    this.dtmService.ruleChange("customLink");
    this.dtmService.sendPageLoadEvent("RetentionModalImpression");

    let dialogRef = this.dialog.open(DialogAlertComponent, {
      disableClose: true,
      panelClass: "pme-dialog-alert-panel",
      autoFocus: false,
      data: { ...data, newHero: true },
    });

    this.sessionStorageService.setAdditionalData({
      byParameter: {
        viewedRetentionModal: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.applyModalCoupon) {
        this.dtmService.customClickEvent(`${currentProduct.identifier}:RetentionModal:AceitarDesconto`)
        this.applyModalCoupon();
      }else{
        this.dtmService.customClickEvent(`${currentProduct.identifier}:RetentionModal:RejeitarModal`)
      }
    });
  }

  applyModalCoupon() {
    let exhibitionPage = this.modalAvailableSteps.find(step => this.route.snapshot['_routerState'].url.includes(step));

    this.sessionStorageService.setAdditionalData({
      byParameter: {
        modalWasDisplayed: true
      }
    });

    if (exhibitionPage === "pagamento") {
      this.discountModalService.setdiscountIdentifierModal(this.discountIdentifierModal);
    } else if (exhibitionPage.indexOf("meu") > -1) {
      //Vitrine
      sessionStorage.setItem("coupon", this.discountIdentifierModal);
    }
  }
}
